import React from 'react';

type IconProps = {
  className?: string;
};

const bgPath = "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V24C36 28.4183 32.4183 32 28 32H8C3.58172 32 0 28.4183 0 24V8Z";

export function TextElementIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d={bgPath} fill="#C4D6D1" />
      <path
        d="M13 10H23"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 10V22"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 22H21"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ImageElementIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d={bgPath} fill="#C4D6D1" />
      <rect
        x="11"
        y="9"
        width="14"
        height="14"
        rx="2"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="15"
        cy="13"
        r="1.5"
        stroke="#34534E"
        strokeWidth="1.33333"
      />
      <path
        d="M11 19L15 15L18 18L21 15L25 19"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function QrElementIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d={bgPath} fill="#C4D6D1" />
      {/* Top-left corner block */}
      <rect
        x="11"
        y="9"
        width="6"
        height="6"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="13"
        y="11"
        width="2"
        height="2"
        fill="#34534E"
      />
      {/* Top-right corner block */}
      <rect
        x="19"
        y="9"
        width="6"
        height="6"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="21"
        y="11"
        width="2"
        height="2"
        fill="#34534E"
      />
      {/* Bottom-left corner block */}
      <rect
        x="11"
        y="17"
        width="6"
        height="6"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="13"
        y="19"
        width="2"
        height="2"
        fill="#34534E"
      />
      {/* Bottom-right data area */}
      <rect x="19" y="17" width="2" height="2" fill="#34534E" />
      <rect x="23" y="17" width="2" height="2" fill="#34534E" />
      <rect x="21" y="19" width="2" height="2" fill="#34534E" />
      <rect x="19" y="21" width="2" height="2" fill="#34534E" />
      <rect x="23" y="21" width="2" height="2" fill="#34534E" />
    </svg>
  );
}

export function BarcodeElementIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d={bgPath} fill="#C4D6D1" />
      <path d="M11 10V22" stroke="#34534E" strokeWidth="2" strokeLinecap="round" />
      <path d="M14 10V22" stroke="#34534E" strokeWidth="1" strokeLinecap="round" />
      <path d="M16.5 10V22" stroke="#34534E" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M19 10V22" stroke="#34534E" strokeWidth="1" strokeLinecap="round" />
      <path d="M21.5 10V22" stroke="#34534E" strokeWidth="2" strokeLinecap="round" />
      <path d="M25 10V22" stroke="#34534E" strokeWidth="1" strokeLinecap="round" />
    </svg>
  );
}

export function ShapeElementIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="36"
      height="32"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d={bgPath} fill="#C4D6D1" />
      <rect
        x="11"
        y="9"
        width="14"
        height="14"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 9L25 23"
        stroke="#34534E"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
